export const { 
    env = '',
    firebaseVapidKey = '',
    conektaPublicKey = '',
    openPayPublicKey = '',
    openPayMerchantId = '',
    cypherKey = '',
    paypalClientId = '',
} = JSON.parse(process.env.NEXT_PUBLIC_CONFIG || {});